import { render, staticRenderFns } from "./TheForgotPassword.vue?vue&type=template&id=66c89c67&"
import script from "./TheForgotPassword.vue?vue&type=script&lang=js&"
export * from "./TheForgotPassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports